import styled from "styled-components";

export const ProductTableContainer = styled.div``;

export const ProductTableNoDataMessageContainer = styled.div`
  width: 100%;
`;

export const ProductTableNoDataMessage = styled.p`
  width: 100%;
  text-align: center;
  font-weight: bold;
`;
